import React, { useMemo } from 'react';
import { useDashboardVariant } from '../../data/domains/config';
import { useProgressiveMacroWeekData } from '../../data/domains/dashboard';
import type { ThemeColors } from '../../shared/theme';
import { DashboardMacroWeekSection } from './DashboardMacroWeekSection';
import { DashboardPlanWeekCardSet1 } from './variants/set1/DashboardPlanWeekCardSet1';

interface DashboardWeeklySectionProps {
  colors: ThemeColors;
  on_browse_plans?: () => void;
}

/** set1: interactive week intake chart. set3: week macro chart. set2 (v2): no macro UI. */
function DashboardMacroWeekSectionWithData({ colors }: { colors: ThemeColors }) {
  const { data, dateFrom, dateTo, loaded } = useProgressiveMacroWeekData({ enable_fetch: false });
  const week_has_any_macros = useMemo(
    () => data.some(d => (d.calories ?? 0) > 0 || (d.protein ?? 0) > 0 || (d.carbs ?? 0) > 0 || (d.fats ?? 0) > 0),
    [data],
  );

  if (!loaded || !week_has_any_macros) {
    return null;
  }

  return <DashboardMacroWeekSection history={data} colors={colors} loaded={loaded} dateFrom={dateFrom} dateTo={dateTo} />;
}

export function DashboardWeeklySection({ colors, on_browse_plans }: DashboardWeeklySectionProps) {
  const variant = useDashboardVariant();

  if (variant === 'set1') {
    return <DashboardPlanWeekCardSet1 colors={colors} on_browse_plans={on_browse_plans} />;
  }

  if (variant === 'set2') {
    return null;
  }

  return <DashboardMacroWeekSectionWithData colors={colors} />;
}
